


import { BrandingStyle, useStateManager } from "@bcm-dev/bcms-vite";
import CustomAccordion, { CustomAccordionContent, CustomAccordionToggle } from "components/custom-ui/CustomAccordion";
import CustomSelect, { CustomSelectItem } from "components/custom-ui/CustomSelect";
import DateSelect from 'components/custom-ui/DateSelect';
import { FormContainer, FormRowView } from 'components/shared';
import IconToggle from "components/shared/views/IconToggle";
import InfoAlertView from "components/shared/views/InfoAlertView";
import { PrimaryButton, SecondaryButton, UIAmountInput, UITextInput } from 'components/ui';
import React from 'react';
import { SVGAsset } from "res";
import TASPositivePayViewChecksNoResultsContent from "../TASPositivePayViewChecksNoResultsContent";

/**
 * @function TASPositivePayViewChecksMobileFormView
 * @return {React.Component}
 * @exported true
 * @description The TAS Positive Pay View Checks mobile content view.
 */
export default function TASPositivePayViewChecksMobileFormView() {
    const { data, ui, onAddChecks, onChange, onClear, onSearch } = useStateManager();
    const search = data.search;

    return (
        <div className="show-on-mobile">
            <div className="flex-container align-top">
                <CustomAccordion isOpen={ true }>
                    <div className="flex-container flex-horizontal align-center">
                        <div className="flex-width">
                            <CustomAccordionToggle className={ "search" } onClick={ undefined }>
                                <IconToggle icon="MagnifyingGlassIcon" text="Search" dataPoint="Search"/>
                            </CustomAccordionToggle>
                        </div>
                    </div>
                    <CustomAccordionContent className="flex-container flex-vertical">
                        <CustomAccordionToggle className="flex-container flex-width close-accordion" onClick={ undefined }>
                            <BrandingStyle className="flex-width" style={{"color" : "search_text_abi22"} } element={<p >SEARCH</p>}/>
                            <SVGAsset className="icon set-width" id="CloseX" data-point="CloseButton" />
                        </CustomAccordionToggle>
                        <FormContainer className="small-form-width">
                            <FormRowView text="Account">
                                <CustomSelect active={ ui.accountSelect.isActive } onChange={ onChange("accountID") }>
                                    <CustomSelectItem value="prompt"></CustomSelectItem>
                                </CustomSelect>
                            </FormRowView>
                            <FormRowView text="Payee">
                                <UITextInput value={ search.payee } onChange={ onChange("payee") } />
                            </FormRowView>
                            <FormRowView text="Status">
                                <CustomSelect value={ search.status } active={ ui.accountSelect.isActive } onChange={ onChange("status") }>
                                    <CustomSelectItem value="all">All</CustomSelectItem>
                                    <CustomSelectItem value="reconciled">Reconciled</CustomSelectItem>
                                    <CustomSelectItem value="notReconciled">Not Reconciled</CustomSelectItem>
                                </CustomSelect>
                            </FormRowView>
                            <FormRowView text="Check Number From">
                                <UITextInput value={ search.checkNumberFrom } onChange={ onChange("checkNumberFrom") } />
                            </FormRowView>
                            <FormRowView text="Check Number To">
                                <UITextInput value={ search.checkNumberTo } onChange={ onChange("checkNumberTo") } />
                            </FormRowView>
                            <div className="flex-container flex-horizontal">
                                <FormRowView className="first-horizontal-row-view issued-date-from" text="Issued Date From">
                                    <DateSelect value={ search.issuedDateFrom } enablePast={ true } onChange={ onChange("issuedDateFrom") }  />
                                </FormRowView>
                                <FormRowView className="issued-date-to" text="Issued Date To">
                                    <DateSelect value={ search.issuedDateTo } enablePast={ true } onChange={ onChange("issuedDateTo") } />
                                </FormRowView>
                            </div>
                            <div className="flex-container flex-horizontal">
                                <FormRowView className="first-horizontal-row-view" text="Minimum Amount">
                                    <UIAmountInput className="amount-field" value={ search.minimumAmount } onChange={ onChange("minimumAmount") } />
                                </FormRowView>
                                <FormRowView text="Maximum Amount">
                                    <UIAmountInput className="amount-field" value={ search.maximumAmount } onChange={ onChange("maximumAmount") } />
                                </FormRowView>
                            </div>
                            <div className="flex-container flex-horizontal button-container">
                                <SecondaryButton className="set-width" text="Clear" onClick={ onClear } />
                                <PrimaryButton className="set-width" text="Search" data-point="Search_Button" onClick={ onSearch } />
                            </div>
                        </FormContainer>
                    </CustomAccordionContent>
                </CustomAccordion>
            </div>
            { !ui.didSearch.isActive && 
            <div className="flex-container flex-horizontal past-review-cutoff-time-container">
                <div className="set-width curfew-alert">
                    <InfoAlertView text="Please use search to find checks." icon={ <SVGAsset id="InfoIcon" /> } />
                </div>
            </div>
            }
            {/* Statically shown until checks are added to the model. */}
            { ui.didSearch.isActive && 
            <TASPositivePayViewChecksNoResultsContent onAddChecks={ onAddChecks } />
            }
        </div>
    )
}